import cx from 'classnames';

import type { DialogProps } from '../../utility';
import { Dialog } from '../../utility';

export function Modal({
  className,
  onClick,
  fullScreen,
  deprecated_width,
  ...rest
}: DialogProps) {
  return (
    <Dialog
      className={cx(
        className,
        'tw-surface-secondary',
        'tw-shadow-80',
        !fullScreen && 'tw-rounded-24',
        'tw-flex',
        'tw-flex-col',
        !fullScreen && 'tw-max-h-[calc(100dvh_-_60px)]',
        fullScreen && 'tw-h-[100dvh]',
        !fullScreen && 'tw-max-w-[calc(100dvw_-_60px)]',
        'tw-overflow-hidden',
      )}
      onClick={(e) => {
        // avoid clicks bubbling to parent
        e.stopPropagation();
        onClick?.(e);
      }}
      fullScreen={fullScreen}
      deprecated_width={deprecated_width}
      {...rest}
    />
  );
}
